module.exports = __webpack_public_path__ + "img/logo_icl.3d6b5558.png";